module.exports = "<span class=layout__tab-layout__header-view-item-text>{{name}}</span>";


//////////////////
// WEBPACK FOOTER
// ../src/layout/tabLayout/headerItem.hbs
// module id = 704
// module chunks = 0